<div
  class="bg-white shadow-md shadow-gray-200 rounded p-5 flex items-center justify-center"
>
  <div class="mt-0 w-full">
    <div
      class="relative flex justify-between border-b-gray-300 border-solid border-b pb-5 mb-6"
    >
      <div
        class="bg-secondary rounded-lg w-5 h-1 left-0 absolute bottom-[-3px]"
      ></div>
      <h4 class="text-xl text-primary">
        {{ label() }}
      </h4>
    </div>
    <ng-content></ng-content>
  </div>
</div>
